const BASE_URL = 'https://schoolhouse.world/faq/en'
const CATEGORY_URL = `${BASE_URL}/collections`
const ARTICLE_URL = `${BASE_URL}/articles`

// HelpDesk Categories
const CATEGORY_SUFFIXES = {
  'sat-bootcamp': '10571074-sat-bootcamp',
  'sat-bootcamp-tutors': '10571067-sat-bootcamp-tutors',
  certification: '10571061-certification',
  tutoring: '10571027-tutoring',
  'trust-safety-privacy': '10571052-trust-safety-and-privacy',
  volunteering: '10499954-volunteering',
  'volunteer-hours': '10571017-volunteer-hours',
}

export type Category = keyof typeof CATEGORY_SUFFIXES

const ARTICLE_SUFFIXES = {
  'what-is-a-portfolio':
    '9961276-what-is-a-schoolhouse-portfolio-how-can-it-boost-my-college-applications',
  'tutor-no-show': '9961110-what-if-my-tutor-doesn-t-show-up-or-my-bootcamp-gets-cancelled',
  'zoom-recording-policy': '9961342-what-happens-to-the-zoom-recordings-from-the-tutoring-sessions',
  'sat-score-700-plus': '9961314-can-i-participate-as-a-learner-if-my-sat-score-is-700-or-above',
  'sat-score-below-400': '9961312-can-i-participate-as-a-learner-if-my-sat-score-is-below-400',
  'research-study-details': '12526302-what-are-the-research-studies-about',
  'safety-report-faq': '9959350-how-do-safety-reports-work',
  'someone-makes-me-uncomfortable': '9959312-what-should-i-do-if-someone-makes-me-uncomfortable',
  'volunteer-hour-policies-in-subworlds':
    '9959590-what-are-the-volunteer-hour-policies-in-subworlds',
  'become-a-tutor': '9959118-how-can-i-become-a-tutor',
  'post-limit': '9960947-why-does-schoolhouse-limit-how-many-times-i-can-post',
  'community-guidelines': '9967517-schoolhouse-world-community-guidelines',
  'volunteer-hour-guidelines':
    '9959343-what-are-the-general-guidelines-for-tracking-volunteer-hours',
  'volunteer-hour-session-prep':
    '9959357-what-are-the-volunteer-hour-tracking-guidelines-for-session-prep',
  'volunteer-hours-form-signed': '9959278-how-do-i-get-a-volunteer-hours-form-signed',
  'volunteer-hours-automatically-tracked':
    '9959445-which-activities-on-the-schoolhouse-platform-are-automatically-tracked-for-volunteer-hours',
  'volunteer-hours-manually-tracked':
    '9959594-which-activities-can-i-manually-log-volunteer-hours-for',
  'what-are-skill-builders': '9960902-what-are-the-sat-math-skill-builders',
  'whats-considered-spamming': '9959401-what-s-considered-spamming',
  'protecting-personal-information': '9967473-protecting-personal-information-at-schoolhouse',
  'age-requirements': '9959333-how-old-do-i-have-to-be-to-create-an-account',
  'session-content': '9967479-what-content-can-schoolhouse-sessions-cover',
  'keeping-behavior-classroom-appropriate': '9959413-keeping-behavior-classroom-appropriate',
  'keeping-interactions-respectful': '9959439-keeping-interactions-respectful',
  'responding-when-someone-makes-you-uncomfortable':
    '9959312-what-should-i-do-if-someone-makes-me-uncomfortable',
  'keeping-sessions-on-topic': '9959527-keeping-conversations-on-topic',
  'self-promotion': '9982147-self-promotion-at-schoolhouse',
  'responding-to-help-channel-requests': '9959289-tips-for-responding-to-help-channel-requests',
  'post-limitations': '9960947-why-does-schoolhouse-limit-how-many-times-i-can-post',
  'providing-mental-health-resources': '9959386-mental-health-resources',
  'off-topic-content-policy': '9982151-off-topic-content-policy',
  'ensuring-inclusive-sessions': '9959536-ensuring-inclusive-sessions',
  'sharing-safety-concerns': '9959350-how-do-safety-reports-work',
  'profane-language': '9982143-profane-language-policy',
  'maintaining-personal-boundaries': '9959446-maintaining-healthy-boundaries-at-schoolhouse',
  'how-accounts-get-flagged': '9959378-why-was-my-account-flagged',
  'tutor-attendance-policy': '9982133-tutor-attendance-policy',
  'forgot-to-prepare-for-targeted-group-practice':
    '9961191-what-should-i-do-if-i-forgot-to-prepare-for-targeted-group-practice-in-advance-of-the-session',
  'community-values': '9961289-what-are-schoolhouse-s-community-values',
  'sat-bootcamp-reschedule': '9961229-what-do-i-do-if-i-need-to-miss-a-day',
  'learner-attendance-policy': '9967511-learner-attendance-policy',
  'drop-in-learner': '9961119-what-does-it-mean-to-be-a-drop-in-learner',
  'sat-bootcamp-senior-tutor': '9959279-how-do-i-qualify-to-become-an-sat-bootcamp-senior-tutor',
  'your-schoolhouse-journey': '9961273-your-schoolhouse-journey',
  'highly-engaging-session': '9959277-what-s-a-highly-engaging-session',
  'what-are-college-admissions-workshops': '9960907-what-are-the-college-admissions-workshops',
  'safety-at-schoolhouse': '9959293-safety-at-schoolhouse',
  'what-topics-is-enrichment-for': '12839124-what-topics-is-enrichment-for',
  mars: '9959580-what-tutoring-rubric-do-you-use-to-peer-review-sessions',
  'series-drop-in-learner': '9961268-what-does-it-mean-to-have-a-drop-in-learner',
  'past-sat-but-havent-taken-sat':
    '9961127-signup-asks-for-past-sat-scores-but-i-haven-t-taken-the-sat-what-do-i-do',
  'active-academic-tutoring': '9959514-what-is-active-academic-tutoring',
  'how-do-i-contact-the-schoolhouse-team': '9959367-how-do-i-contact-the-schoolhouse-team',
  'what-is-the-school-day-sat': '10389602-what-is-the-school-day-sat',
  'dialogues-policies-faq': '10262851-dialogues-policies-faq',
  'when-i-delete-my-account': '9967463-what-happens-when-i-delete-my-account',
  'unable-to-use-certification-recording-system':
    '9959426-what-if-i-don-t-have-a-webcam-or-am-unable-to-use-the-certification-recording-system',
  'removed-from-series': '11010474-what-to-do-if-you-ve-been-removed-from-a-series',
  'give-feedback-to-learner': '9959474-how-do-i-give-feedback-to-a-learner-as-a-tutor',
  'age-verification-for-new-users': '11964918-age-verification-for-new-users',
  'sp-and-badges': '9959607-schoolhouse-points-sp-and-badges',
  'how-does-schoolhouse-use-ai': '9961296-how-does-schoolhouse-use-ai',
  'can-i-plan-a-session-with-only-one-learner':
    '9959475-can-i-plan-a-session-with-only-one-learner',
  'what-content-can-schoolhouse-sessions-cover':
    '9967479-what-content-can-schoolhouse-sessions-cover',
  'what-am-i-not-permitted-to-do-while-hosting-sessions':
    '9959508-what-am-i-not-permitted-to-do-while-hosting-sessions',
  'can-i-host-multiple-sat-bootcamps': '9959430-can-i-host-multiple-sat-bootcamps',
}

export type Article = keyof typeof ARTICLE_SUFFIXES

export function getUrl(category?: Category): string {
  if (category == null) {
    return BASE_URL
  }
  return `${CATEGORY_URL}/${CATEGORY_SUFFIXES[category]}`
}

export function getArticleUrl(article: Article): string {
  return `${ARTICLE_URL}/${ARTICLE_SUFFIXES[article]}`
}
